.root {
  border-radius: 8px;

  &[data-size='xs'] {
    font-size: 12px;
  }

  &[data-size='sm'] {
    height: 28px;
    font-size: var(--mantine-font-size-textSm);
    font-weight: 500;
  }

  &[data-size='md'] {
    height: 40px;
    font-size: var(--mantine-font-size-textSm);
    font-weight: 600;
  }

  &[data-size='lg'] {
    height: 44px;
    font-size: var(--mantine-font-size-textSm);
    font-weight: 600;
  }

  &[data-size='xl'] {
    height: 48px;
    font-size: var(--mantine-font-size-textMd);
    font-weight: 600;
    border-radius: 12px;
  }

  &[data-size='xxl'] {
    height: 60px;
    font-size: var(--mantine-font-size-lg);
    font-weight: 600;
    border-radius: 16px;
  }

  &[data-variant='default'] {
    border: 1px solid var(--mantine-color-gray-4);
    border-radius: 8px;
    background-color: transparent;
    color: var(--mantine-color-gray-10);
  }

  &[data-variant='secondary'] {
    border: 1px solid var(--mantine-color-gray-4);
    border-radius: 12px;
    background-color: white;
    color: var(--mantine-color-gray-10);
  }

  &[data-variant='filled'] {
    color: var(--mantine-color-black);
    border-radius: 12px;
  }

  &[data-variant='filled-white'] {
    border-radius: 12px;
  }

  &[data-variant='filled-secondary'] {
    color: var(--mantine-color-white);
  }

  &[data-variant='subtle'] {
    &:hover {
      background-color: var(--mantine-color-gray-0);
    }

    &[data-active='true'] {
      background-color: var(--mantine-color-gray-0);
    }
  }

  &[data-variant='pill'] {
    border-radius: 100px;
    border: 1px solid var(--mantine-color-gray-3);
    background-color: var(--mantine-color-white);
    color: var(--mantine-color-gray-9);
    padding: 8px 14px;

    &:disabled {
      border-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='filled-pill'] {
    min-width: 130px;
    border-radius: 100px;
    --button-bg: var(--mantine-color-brand-5);
    color: var(--mantine-color-gray-10);
    padding: 8px 14px;
    font-weight: 600;
    font-size: 14px;
  }

  &[data-variant='filled-pill-black'] {
    min-width: 130px;
    border-radius: 100px;
    --button-bg: var(--mantine-color-gray-10);
    --button-hover: var(--mantine-color-gray-9);
    color: var(--mantine-color-white);
    padding: 8px 14px;
    font-weight: 600;
    font-size: 14px;

    &:disabled {
      border-color: var(--mantine-color-gray-3);
      background-color: var(--mantine-color-white);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='text'] {
    color: var(--mantine-color-brand-6);
    font-weight: 500;
    font-size: 14px;
    padding: 0;
    margin: 0;
    background-color: transparent;

    &:hover {
      background-color: transparent;
      color: var(--mantine-color-brand-7);
    }
  }

  &[data-variant='text-action'] {
    color: var(--mantine-color-brand-7);
    font-weight: 600;
    font-size: 14px;
    padding: 0;
    margin: 0;
    background-color: transparent;
    height: unset;

    .label {
      overflow: visible !important;
    }

    &:hover {
      background-color: transparent;
      color: var(--mantine-color-brand-6);
    }
  }

  &[data-variant='outline-black'] {
    border: 1px solid var(--mantine-color-gray-4);
    border-radius: 8px;
    color: var(--mantine-color-gray-10);
    background-color: transparent;
    font-size: var(--mantine-font-size-sm);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-gray-0);
    }

    &:disabled {
      border-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='outline-black-dismissable'] {
    border: 1px solid var(--mantine-color-black);
    border-radius: 8px;
    color: var(--mantine-color-black);
    background-color: transparent;
    font-size: var(--mantine-font-size-sm);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-gray-0);
    }

    &:disabled {
      border-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='black'] {
    color: var(--mantine-color-white);
    background-color: var(--mantine-color-gray-10);

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-gray-9);
    }

    &:disabled {
      background-color: var(--mantine-color-gray-3);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='primary'] {
    background-color: var(--mantine-color-brand-6);
    color: var(--mantine-color-white);
    border-radius: 12px;
    border: 2px solid;
    border-image-source: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.12) 0%,
      rgba(255, 255, 255, 0) 100%
    );

    &:hover:not([data-disabled]) {
      background-color: var(--mantine-color-brand-6);
    }

    &[data-disabled] {
      background-color: var(--mantine-color-gray-1);
      border-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-gray-4);
    }
  }

  &[data-variant='button-group'],
  &[data-variant='button-group-active'] {
    border: 1px solid var(--mantine-color-gray-3);
    background-color: var(--mantine-color-white);
    color: var(--mantine-color-gray-9);
  }

  &[data-variant='button-group-active'] {
    background-color: var(--mantine-color-gray-1);
  }

  &[data-variant='tab-active'] {
    border-radius: 6px;
    background-color: var(--mantine-color-brand-1);
    color: var(--mantine-color-brand-8);
    font-size: var(--mantine-font-size-textSm);
    font-weight: 700;
    padding: var(--mantine-spacing-xxs) var(--mantine-spacing-xs);
  }

  &[data-variant='tab-inactive'] {
    border-radius: 6px;
    background-color: white;
    color: var(--mantine-color-gray-6);
    font-size: var(--mantine-font-size-textSm);
    font-weight: 700;
    padding: var(--mantine-spacing-xxs) var(--mantine-spacing-xs);
  }
}
